export default __webpack_public_path__ + "static/media/FlyingFrog18.5628c3ea.png";